import { render, staticRenderFns } from "./UserNavigationMobile.vue?vue&type=template&id=081b2140&"
import script from "./UserNavigationMobile.vue?vue&type=script&lang=ts&"
export * from "./UserNavigationMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/vercel/path0/components/Btn.vue').default})
